<script>
  import { _ } from "../stores/index"
  import { ContractsRepository } from "../repositories/index"
  import { Flex, FlexItem, Button, Form, Submit, TextField, Modal, Select, SelectItem } from "@gl/design-system"
  import { createEventDispatcher, onMount } from "svelte"
  import { isValidName } from "../utils/validators"
  const dispatch = createEventDispatcher()

  export let active

  let loading = {}

  let form = {}

  let customers = []
  let authorizers = []

  async function fetchCustomers() {
    loading.customers = true

    try {
      const result = await ContractsRepository.getCustomers()
      customers = result.list
      form.customerId = customers[0].id
    } finally {
      loading.customers = false
    }
  }

  async function fetchAuthorizers() {
    loading.authorizers = true

    try {
      const result = await ContractsRepository.getAuthorizers()
      authorizers = result.list
      form.authorizerId = authorizers[0].id
    } finally {
      loading.authorizers = false
    }
  }

  const onSubmit = async () => {
    try {
      loading.submit = true

      await ContractsRepository.addContract(form)
    } finally {
      loading.submit = false
      dispatch("success")
    }
  }

  onMount(() => {
    fetchCustomers()
    fetchAuthorizers()
  })
</script>

<Modal bind:active boxed>
  <div class="gl-title mb-4">
    {$_("contracts.add")}
  </div>
  <Form validationMode="eager">
    <TextField
      bind:value={form.name}
      id="app-name"
      label={$_("common.name")}
      required={$_("validations.required")}
      validate={(value) => isValidName(value)}
      maxLength={50}
      config={{ characterCount: $_("character.count") }}
    />

    <Select label={$_("common.customer")} bind:value={form.customerId} id="customers">
      {#each customers || [] as customer}
        <SelectItem label={customer.name} value={customer.id} />
      {/each}
    </Select>

    <Select label={$_("common.authorizer")} bind:value={form.authorizerId} id="authorizers">
      {#each authorizers || [] as authorizer}
        <SelectItem label={authorizer.name} value={authorizer.id} />
      {/each}
    </Select>

    <Flex>
      <FlexItem>
        <Submit loading={loading.submit} on:submit={onSubmit} label={$_("buttons.add")} />
      </FlexItem>
      <FlexItem class="ml-4">
        <Button outlined on:click={() => dispatch("close")}>
          {$_("buttons.cancel")}
        </Button>
      </FlexItem>
    </Flex>
  </Form>
</Modal>
